export const ISSUE_LOG_WORK_PREFIX = 'issue-log-work';
